export default __webpack_public_path__ + "static/char-s-sp03-ko-f37411ea1b4cb175515c032b60321e42.webp";